/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailStorageStatsSentItems
 */
export interface EmailStorageStatsSentItems {
    /**
     * 
     * @type {number}
     * @memberof EmailStorageStatsSentItems
     */
    totalItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EmailStorageStatsSentItems
     */
    sizeInBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailStorageStatsSentItems
     */
    sizeMB?: string;
}

/**
 * Check if a given object implements the EmailStorageStatsSentItems interface.
 */
export function instanceOfEmailStorageStatsSentItems(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmailStorageStatsSentItemsFromJSON(json: any): EmailStorageStatsSentItems {
    return EmailStorageStatsSentItemsFromJSONTyped(json, false);
}

export function EmailStorageStatsSentItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailStorageStatsSentItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalItemCount': !exists(json, 'totalItemCount') ? undefined : json['totalItemCount'],
        'sizeInBytes': !exists(json, 'sizeInBytes') ? undefined : json['sizeInBytes'],
        'sizeMB': !exists(json, 'sizeMB') ? undefined : json['sizeMB'],
    };
}

export function EmailStorageStatsSentItemsToJSON(value?: EmailStorageStatsSentItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalItemCount': value.totalItemCount,
        'sizeInBytes': value.sizeInBytes,
        'sizeMB': value.sizeMB,
    };
}

